import { render, staticRenderFns } from "./PromoImages.vue?vue&type=template&id=0fd1b8f8&scoped=true"
import script from "./PromoImages.vue?vue&type=script&lang=js"
export * from "./PromoImages.vue?vue&type=script&lang=js"
import style0 from "./PromoImages.vue?vue&type=style&index=0&id=0fd1b8f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd1b8f8",
  null
  
)

export default component.exports